module.exports = __webpack_public_path__ + "static/media/PCW_IPOIntelligence_base.0e89708b.png";